import api from '../utils/apiClient';

const collaborationService = {
  // ── Collaborations ──────────────────────────────────────────────────────────
  getCollaborations: (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.influencer_id) params.append('influencer_id', filters.influencer_id);
    if (filters.status) params.append('status', filters.status);
    const qs = params.toString();
    return api.get(`/api/admin/influencer-collaborations${qs ? `?${qs}` : ''}`);
  },

  getCollaboration: (id) => api.get(`/api/admin/influencer-collaborations/${id}`),

  createCollaboration: (data) => api.post('/api/admin/influencer-collaborations', data),

  updateCollaboration: (id, data) => api.put(`/api/admin/influencer-collaborations/${id}`, data),

  updateCollaborationStatus: (id, status) =>
    api.patch(`/api/admin/influencer-collaborations/${id}/status`, { status }),

  deleteCollaboration: (id) => api.del(`/api/admin/influencer-collaborations/${id}`),

  // ── Collaboration Content ───────────────────────────────────────────────────
  getContent: (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.collaboration_id) params.append('collaboration_id', filters.collaboration_id);
    if (filters.influencer_id) params.append('influencer_id', filters.influencer_id);
    const qs = params.toString();
    return api.get(`/api/admin/collaboration-content${qs ? `?${qs}` : ''}`);
  },

  createContent: (data) => api.post('/api/admin/collaboration-content', data),

  updateContent: (id, data) => api.put(`/api/admin/collaboration-content/${id}`, data),

  deleteContent: (id) => api.del(`/api/admin/collaboration-content/${id}`),

  // ── Outreach Templates ──────────────────────────────────────────────────────
  getTemplates: () => api.get('/api/admin/outreach-templates'),

  createTemplate: (data) => api.post('/api/admin/outreach-templates', data),

  updateTemplate: (id, data) => api.put(`/api/admin/outreach-templates/${id}`, data),

  setDefaultTemplate: (id) => api.patch(`/api/admin/outreach-templates/${id}/set-default`, {}),

  deleteTemplate: (id) => api.del(`/api/admin/outreach-templates/${id}`),

  renderTemplate: (body, influencerOrName, brandName = 'KAAY') => {
    const name = typeof influencerOrName === 'string' ? influencerOrName : (influencerOrName?.name || '');
    const followerCount = typeof influencerOrName === 'string' ? '' : (influencerOrName?.follower_count?.toLocaleString() || '');
    const city = typeof influencerOrName === 'string' ? '' : (influencerOrName?.city || '');
    const niche = typeof influencerOrName === 'string' ? '' : (influencerOrName?.niche || '');
    return body
      .replace(/\{\{influencer_name\}\}/g, name)
      .replace(/\{\{brand_name\}\}/g, brandName)
      .replace(/\{\{follower_count\}\}/g, followerCount)
      .replace(/\{\{city\}\}/g, city)
      .replace(/\{\{niche\}\}/g, niche);
  },

  // ── Insights ────────────────────────────────────────────────────────────────
  getInsights: (influencerId) => api.get(`/api/admin/influencers/${influencerId}/insights`),
};

export default collaborationService;
